// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".copilot-message-steps{border-top:1px solid var(--dash-border-color)}.copilot-message-steps__close-btn{background:#eee;border-bottom-left-radius:0;border-bottom-right-radius:0;border-left:1px solid var(--dash-border-color);border-right:1px solid var(--dash-border-color);border-top:1px solid var(--dash-border-color);border-top-left-radius:4px;border-top-right-radius:4px;position:absolute;right:24px;top:-36px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
